import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import DynamicForm from "../../../components/DynamicForm";
import FormSkeletonLoader from "../../../components/FormSkeletonLoader";
import {
  sponsorMasterUserFields,
  sponsorMasterUserValidationSchema,
} from "../../../Schema/SponsorMasterUserSchema";
import {
  useDeleteSponsorMasterUser,
  useGetSponsorMasterUserDetails,
  useUpdateSponsorMasterUser,
} from "../../../custom-hooks/queries";
import NotificationModal from "../../../components/NotificationModal";
import Modal from "../../../components/Modal";

const ManageSponsorMasterUser = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [show, setShow] = React.useState(false);
  const [message, setMessage] = React.useState("");
  const {
    mutate: deleteUser,
    isLoading: isDeleting,
    isError: deleteError,
  } = useDeleteSponsorMasterUser();
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const { data: userDetails, isLoading } = useGetSponsorMasterUserDetails(id);
  const { mutate: updateUser, isError } = useUpdateSponsorMasterUser();

  const defaultValues = {
    email: userDetails?.email || "",
    first_name: userDetails?.first_name || "",
    last_name: userDetails?.last_name || "",
    phone_number: userDetails?.phone_number || "",
    office_phone_number: userDetails?.office_phone_number || "",
    contact_preference: userDetails?.contact_preference || "Office_Phone",
    sponsor_id: userDetails?.sponsor_id || "",
  };

  const onSubmit = (data) => {
    const updateData = {
      email: data.email,
      first_name: data.first_name,
      last_name: data.last_name,
      phone_number: data.phone_number,
      office_phone_number: data.office_phone_number,
      contact_preference: data.contact_preference,
      sponsor_id: userDetails.sponsor_id,
    };

    updateUser(
      { id, userData: updateData },
      {
        onSuccess: () => {
          setMessage("User updated successfully");
          setShow(true);
          setTimeout(() => navigate("/Backend/Users/SponsorMasterUsers"), 2000);
        },
        onError: (error) => {
          setMessage("Failed to update user");
          setShow(true);
        },
      }
    );
  };

  if (isLoading) {
    return <FormSkeletonLoader />;
  }

  const handleDelete = () => {
    deleteUser(id, {
      onSuccess: () => {
        setMessage("User deleted successfully");
        setShow(true);
        setDeleteModalOpen(false);
        setTimeout(() => navigate("/Backend/Users/SponsorMasterUsers"), 2000);
      },
      onError: (error) => {
        setMessage(error.response?.data?.message || "Failed to delete user");
        setShow(true);
        setDeleteModalOpen(false);
      },
    });
  };
  const manageSponsorMasterUserFields = [
    ...sponsorMasterUserFields.filter((field) => field.name !== "sponsor_id"),
  ];

  return (
    <div className="w-full">
      <DynamicForm
        formTitle="Update Sponsor Master User"
        formDescription="Update the information below to modify the Sponsor Master User details."
        fields={manageSponsorMasterUserFields}
        validationSchema={sponsorMasterUserValidationSchema}
        onSubmit={onSubmit}
        defaultValues={defaultValues}
        isUpdate={true}
        onDelete={() => setDeleteModalOpen(true)}
        className="w-full"
      />
      <Modal
        open={deleteModalOpen}
        setOpen={setDeleteModalOpen}
        title="Delete User"
        description="Are you sure you want to delete this user? This action cannot be undone."
        textBtn="Delete"
        onClick={handleDelete}
        loading={isDeleting}
        color="bg-red-400"
        hoverColor="hover:bg-red-700"
      />
      <NotificationModal
        open={show}
        setOpen={setShow}
        desc={message}
        title={isError || deleteError ? "Error" : "Success"}
        error={isError || deleteError}
      />
    </div>
  );
};

export default ManageSponsorMasterUser;
